import { Banner, Text } from '@spotify-internal/encore-web';
import { Copy, LoadingOverlay } from '@spotify/confidence-core-react';

import { Branding } from './Branding';
import { IntroStep } from './IntroStep';
import { useAccountLogin } from './hooks/useAccountLogin';
import type { InviteResponse } from './hooks/useInvite';
import final from './img/final.png';
import { getLoginAuthErrorMessage } from './signupUtils';

import styles from './AccountCreated.module.css';

export const AccountCreated = ({
  createdAccount,
}: {
  createdAccount: NonNullable<InviteResponse['createdAccount']>;
}) => {
  const { error, loading, login } = useAccountLogin(createdAccount.loginId);
  const workspaceId = createdAccount.loginId;

  return (
    <>
      <Branding />
      <IntroStep
        title="Wonderful! You're all set!"
        img={final}
        description={
          <>
            {error && (
              <Banner colorSet="negative" contextual role="alert">
                {getLoginAuthErrorMessage(error)}
              </Banner>
            )}
            <Text as="div" variant="bodyMedium">
              Your workspace ID is
            </Text>
            <span className={styles.workspaceId}>
              <Text
                as="span"
                variant="bodyMedium"
                semanticColor="textBrightAccent"
              >
                {workspaceId}
              </Text>
              <Copy
                value={workspaceId}
                variant="compact"
                label="Copy workspace ID"
              />
            </span>
            <Text as="div" variant="bodySmall" semanticColor="textSubdued">
              You&apos;ll need this if someone wants to join your workspace.
            </Text>
          </>
        }
        buttonLabel="Log in"
        onNext={login}
        disabled={loading}
      />
      <LoadingOverlay loading={loading} />
    </>
  );
};
